/**
 * Seed Indent, Packing → Store Processed Seeds / Printing Section → Dispatch (`TSI/…`, design
 * docs/designs/mtn-seed-indent.md Phase 3, user 2026-11-04; today a pink handwritten indent). Raised from
 * a released WB Packing Slip: every column comes from the slip (crop, variety, lot, qty, UPS, pouches,
 * DoT, validity, MRP). The Printing Section records the label serials it printed; the Packing Slip must
 * then use exactly those; Dispatch acknowledges only once the packed lot is in PSW. It moves no stock.
 * Not the Stores e-Indent (`stores_indents`, pouches and rolls).
 */
import { slocUpdation } from "./processing";
import type { FormConfig } from "./types";

export const SEED_INDENT_FORM = "seed_indent";

export const seedIndentForm: FormConfig = {
  ...slocUpdation,
  code: SEED_INDENT_FORM,
  docType: "packaging",
  title: "Seed Indent",
  numberPrefix: "TSI",
  raisedOnHandheld: false,
  lineColumns: ["lot_number", "crop", "variety", "stage", "actions"],
};

/**
 * raised → printed (serials recorded) → packed (its WB slip's Packing Slip has posted the packed lot:
 * read from the slip, never stored) → received (Dispatch). Cancelled by status.
 */
export const SEED_INDENT_STAGES = [
  "raised",
  "printed",
  "packed",
  "received",
  "cancelled",
] as const;
export type SeedIndentStage = (typeof SEED_INDENT_STAGES)[number];

export const SEED_INDENT_STAGE_LABELS: Readonly<
  Record<SeedIndentStage, string>
> = {
  raised: "Raised – with Printing",
  printed: "Labels printed",
  packed: "Packed – in PSW",
  received: "Received by Dispatch",
  cancelled: "Cancelled",
};

export const SEED_INDENT_CODES = {
  raise: "packaging.seed_indent.raise",
  print: "packaging.seed_indent.print",
  receive: "orders.seed_indent.receive",
} as const;
